import React from 'react';
import ReactDOM from 'react-dom';
import { Loading } from 'carbon-components-react';
import { Close16, ErrorFilled16 } from '@carbon/icons-react';

interface UploadPipelineOverlayProps {
  variant: 'processing' | 'error';
  onClose?: () => void;
}

const UploadPipelineOverlay: React.FC<UploadPipelineOverlayProps> = ({
  variant,
  onClose
}) => {
  const overlay = (
    <div
      className={`bel-upload-pipeline-overlay bel-upload-pipeline-overlay--${variant}`}
      role={variant === 'error' ? 'alert' : undefined}
      aria-live={variant === 'processing' ? 'polite' : undefined}
      aria-busy={variant === 'processing' ? true : undefined}
    >
      <div className="bel-upload-pipeline-overlay__backdrop" />
      {variant === 'error' ? (
        <div className="bel-upload-pipeline-overlay__card bel-upload-pipeline-overlay__card--error">
          <div className="bel-upload-pipeline-overlay__error-icon" aria-hidden>
            <ErrorFilled16 />
          </div>
          <div className="bel-upload-pipeline-overlay__text">
            <p className="bel-upload-pipeline-overlay__title">
              Unable to process your file
            </p>
            <p className="bel-upload-pipeline-overlay__subtitle">
              Please try again.
            </p>
          </div>
          <button
            type="button"
            className="bel-upload-pipeline-overlay__close"
            aria-label="Dismiss error"
            onClick={onClose}
          >
            <Close16 />
          </button>
        </div>
      ) : (
        <div className="bel-upload-pipeline-overlay__card bel-upload-pipeline-overlay__card--processing">
          <Loading withOverlay={false} small />
          <div className="bel-upload-pipeline-overlay__text">
            <p className="bel-upload-pipeline-overlay__title">
              Processing your file...
            </p>
            <p className="bel-upload-pipeline-overlay__subtitle">
              This may take a moment. Please stay on this screen while we
              finish.
            </p>
          </div>
        </div>
      )}
    </div>
  );

  return ReactDOM.createPortal(overlay, document.body);
};

export default UploadPipelineOverlay;
